import { UseQueryResult, useQuery } from 'react-query'

import httpClient from 'services/http-client'

export const GET_ALL_FAVOURITE_BRANDS = '/retailers/favourites/brands'

export type FavouriteBrandDetails = {
  key: string
  name: string
  image: string
  country: string
  minOrder: number
  isActive: boolean
}

export const useGetFavouriteBrands = (enabled = true): UseQueryResult<FavouriteBrandDetails[]> =>
  useQuery({
    enabled: enabled,
    queryKey: [GET_ALL_FAVOURITE_BRANDS],
    queryFn: async () => {
      const { data: favouriteBrands } = await httpClient.get<FavouriteBrandDetails[]>(GET_ALL_FAVOURITE_BRANDS)
      return favouriteBrands
    },
  })
